import { useState, useEffect } from 'react';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
          >
            <span className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl"></i>
            </span>
            <span className="text-lg font-bold font-heading">韩国漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                isHome
                  ? scrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-white/20 text-white'
                  : location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-background-50'
                    : scrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : scrolled || !isHome
                  ? 'text-foreground-700 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 text-sm rounded-lg hover:bg-background-100 text-foreground-800 whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm rounded-lg hover:bg-background-100 text-foreground-800 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm rounded-lg hover:bg-background-100 text-foreground-800 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}